<template>
    <div>
        <navigation-bar Close/>
        <div class="transfer main">
            <category-content class="text-left pt-0">
                <ul>
                    <li class="date">{{endAtDate}}</li>
                    <li><h2 class="brand overflow-omitted">{{commodityName}}</h2></li>
                </ul>
            </category-content>
            <div>
                <category-header title="轉贈對象">
                    <div slot="more" class="buttons" v-if="offersType === ticketType.Coupon.id || giftMethodList.indexOf('3') !== -1">
                        <!--                    <el-button type="text" @click="showTargetInputDialog('轉贈對象')">-->
                        <!--                        <img src="@/assets/images/scan2.svg" alt="">-->
                        <!--                    </el-button>-->
                        <el-button type="text" @click="gotoCamera" >
                            <img src="@/assets/images/qrcode.svg" alt="掃碼">
                        </el-button>
                    </div>
                </category-header>
                <div class="border-input d-flex">
                    <div v-if="destName" class="dest-img">
                        <el-image :src="destImg" fit="cover"/>
                    </div>
                    <el-input class="border-input border-0 m-0 flex-1 red"
                              placeholder="請輸入對方會員ID或電話號碼"
                              readonly v-model="destName"
                              @click.native="showTargetInputDialog('轉贈對象')"/>
                </div>
                <category-header title="轉贈數量">
                    <span slot="more" class="text">
                      可轉贈{{ticketTypeItem.unit}}數<span>{{maxAvailableCount}}</span>{{ticketTypeItem.unit}}
                    </span>
                </category-header>

                <number-controller :params="numberControllerParams" @triggerEvent="numberControllerEvent"/>

                <category-header title="備註欄" class="mb-2"/>
                <el-input
                        class="border-input"
                        placeholder="此備註欄位僅您本人可以查看"
                        type="textarea"
                        :rows="4"
                        v-model="remarks"></el-input>

                <category-header title="留言給對方" class="mb-2"/>
                <el-input
                        class="border-input"
                        placeholder="請輸入文字內容"
                        type="textarea"
                        :rows="4"
                        v-model="message"></el-input>
            </div>
            <div slot="footer" class="footer-button">
                <el-button @click="goBack" class="cancel" round>取消</el-button>
                <el-button type="primary" @click="onConfirmBtnClick" round>送出</el-button>
            </div>
            <loading
                    :active.sync=isLoading
                    :can-cancel="false"
                    :is-full-page="true">
            </loading>
            <target-input-dialog :value="isShowTargetInputDialog"
                                 :outerContent="dialogMsg"
                                 :isCancel="true"
                                 :appendToBody="isWeb"
                                 @result="onTargetInputDialogResult"/>
            <target-confirm-dialog :value="isShowTargetConfirmDialog"
                                   :icon="tmpImg"
                                   :outerContent="dialogMsg"
                                   :name="tmpName"
                                   :isCancel="true"
                                   :appendToBody="isWeb"
                                   @result="onTargetConfirmDialogResult"/>
            <comm-dialog :value="isShowDialog"
                         :outerContent="dialogMsg"
                         :mainContent="dialogMsgMain"
                         :icon="icons"
                         :isCancel="false"
                         :appendToBody="isWeb"
                         @result="onDialogResult"/>
        </div>
    </div>

</template>

<script>

    import * as constDefine from "@/store/constDefine";

    const goToList = 1;
    const goToBack = 2;

    import {checkPhone, checkPassword} from "@/util/validators";
    import CategoryContent from '@/components/category/Content.vue'
    import CategoryHeader from '@/components/category/Header.vue';
    import CommDialog from '@/components/CommDialog.vue';
    import TargetInputDialog from "./components/TargetInputDialog";
    import TargetConfirmDialog from "./components/TargetConfirmDialog";
    import NumberController from "@/components/NumberController";

    export default {
        name: "Coupon",
        props: {
            isWeb: Boolean,
            dataTokenWeb: {default: ''},
        },
        components: {
            CategoryContent,
            CategoryHeader,
            CommDialog,
            TargetInputDialog,
            TargetConfirmDialog,
            NumberController,
        },
        data() {
            return {
                dataToken: this.isWeb? (this.dataTokenWeb.dataToken ?? "" ): (this.$route.query.dataToken ?? ""),
                dataObject: {},
                id: this.isWeb? parseInt(this.dataTokenWeb.id || '0') : parseInt(this.$route.query.id || '0'),    //該票券在個人資料表中的 id
                couponId: this.isWeb? parseInt(this.dataTokenWeb.couponId || '0') :  parseInt(this.$route.query.couponId || '0'),   //票券種類 id
                offersType: this.isWeb? parseInt(this.dataTokenWeb.offersType || constDefine.TicketType.Coupon.id) : parseInt(this.$route.query.offersType || constDefine.TicketType.Coupon.id),
                ticketType: {...constDefine.TicketType},
                isShowDialog: false,
                //彈框大標
                dialogMsg: '',
                //彈框小標
                dialogMsgMain: '',
                //彈框圖示
                icons: require('@/assets/images/dialog_question.svg'),
                destToken: '',       //要轉贈的對象的 token
                transAmount: 1,      //轉贈票券張數
                maxAvailableCount: 1,      //最大可轉贈的票券
                commodityName: '',   //物品名稱
                endAtDate: '',     //到期日, yyyy-MM-dd
                convertEnd: '',     //轉贈結束時間
                destName: '',       //轉贈對象的名稱 (顯示用)
                destPhone: '',      //轉贈對象的手機號碼 或 userCode
                destImg: '',        //轉贈對象的頭像
                tmpName: '',        //暫存轉贈對象的名稱 (顯示用)
                tmpPhone: '',       //暫存轉贈對象的手機號碼 或 userCode
                tmpImg: '',         //暫存轉贈對象的頭像
                remarks: '',    //備註
                message: '',    //留言
                isLoading: false,     //是否顯示載入動畫
                dialogResult: 0,
                isShowTargetInputDialog: false,
                isShowTargetConfirmDialog: false,
                numberControllerParams: {
                  default: 1,
                  min: 1,
                  max: 1,
                },
                ticketTypeItem: {
                    id: 0,
                    name: "",
                    unitName: "",
                    unit: "",
                    value: "",
                },
                giftMethodList: [],
                stageInfo: {},
                isCertificate: false,
                isGoBack: false,
                fromRoute: {},
            }
        },
        created() {
            try {
                this.dataObject = this.$crypto.uriComponentToObject(this.dataToken)
                if (this.id === 0 && this.couponId === 0 && this.dataObject.usedType === "TransferCoupon" && this.dataObject.id > 0) {
                    this.id = this.dataObject.id
                    this.couponId = this.dataObject.couponId
                    this.offersType = this.dataObject.offersType
                    this.isGoBack = this.dataObject.isGoBack
                }
            } catch (e) {
                this.dataObject = {}
            }

            if(this.offersType === this.ticketType.GiftPack.id) {
                this.ticketTypeItem = this.ticketType.GiftPack
            } else {
                this.ticketTypeItem = this.ticketType.Coupon
            }

            //讀取掃描結果
            let scanResult = sessionStorage.getItem('cameraResult');
            if (scanResult !== null && scanResult !== '') {
                //讀取完要清除，要再取得結果就要重新掃描
                sessionStorage.setItem('cameraResult', '');
                this.onScanResult(scanResult);
            }
        },
        mounted() {
            if(this.offersType === this.ticketType.GiftPack.id) {
                this.getMySelfGiftPackInfoById();
            } else {
                this.callGetMySelfCouponInfoByIdApi(this.id, this.couponId);
            }
        },
        beforeDestroy() {

        },
        beforeRouteEnter(to, from, next) {
            next(
                vm => {
                    vm.fromRoute = from;
                }
            );
        },
        methods: {

            /** 流程 : 輸入電話，代號或是掃描，都會取得對方 userCode，
             * 再將 userCode 填入框中，統一用 userCode 來當轉贈對象 */

            /** 開啓相機 */
            gotoCamera: function () {
                this.$router.push({name: `ScanCode`});
            },

            /** 接收掃描結果 */
            onScanResult: function (value) {
                if (/vcard/g.test(value.toLowerCase())) {
                    this.showDialog("請用本 app 的個人條碼來掃描");
                } else {
                    // this.destToken = value;
                    //解析 token
                    let decodeToken = this.$crypto.decryptText(value);
                    let decodeAry = decodeToken.split(';');
                    if (decodeAry !== undefined && decodeAry.length > 0) {
                        let userId = decodeAry[0];
                        this.doTargetConfirm(userId, '', '');
                    } else {
                        this.showDialog("掃描錯誤，請確認是否爲本 app 產生的 QRcode");
                    }
                }
            },

            /** 顯示 dialog */
            showDialog: function (msg) {
                this.dialogMsg = msg;
                this.isShowDialog = true;
            },

            /** dialog事件 返回 */
            onDialogResult() {
                this.isShowDialog = false;

                if (this.dialogResult === goToList) {
                    this.dialogResult = 0;
                    if (!this.isWeb) {
                        this.$router.push({name: 'Gift', params: {activeCategory: 'coupon', activeTab: 'use'}});
                    } else {
                        //單店網頁版用
                        this.$emit('close', true);
                    }
                } else if (this.dialogResult === goToBack) {
                    if (!this.isWeb) {
                        this.$router.go(-1)
                    } else {
                        //單店網頁版用
                        this.$emit('close', true);
                    }
                }
            },

            /** 顯示 輸入轉贈對象 dialog */
            showTargetInputDialog: function (msg) {
                if(this.offersType === this.ticketType.Coupon.id || this.giftMethodList.indexOf('1') !== -1) {
                    this.dialogMsg = msg;
                    this.isShowTargetInputDialog = true;
                } else {
                    this.showDialog(`未開放手機號碼轉贈`);
                }
            },

            /** 輸入轉贈對象dialog事件 返回 */
            onTargetInputDialogResult: function (result, type, target) {
                this.isShowTargetInputDialog = false;
                if (result) {
                    if (checkPhone(target)) {
                        this.doTargetConfirm('', target, '');

                    } else {
                        this.doTargetConfirm('', '', target);
                    }
                }
            },

            /** 顯示 確認轉贈對象 dialog */
            showTargetConfirmDialog: function () {
                this.dialogMsg = '確認對象';
                this.isShowTargetConfirmDialog = true;
            },

            /** 確認轉贈對象dialog事件 返回 */
            onTargetConfirmDialogResult: function (result, type) {
                this.isShowTargetConfirmDialog = false;
                if (result) {
                  this.destName = this.tmpName;
                  this.destPhone = this.tmpPhone;
                  this.destImg = this.tmpImg;
                }
            },

            /** 確定轉贈 */
            onConfirmBtnClick: function () {

                if(this.destPhone === "" && this.destToken === "") {
                  this.showDialog('請輸入轉贈對象');
                } else if (isNaN(this.transAmount) || this.transAmount <= 0 || this.transAmount > this.maxAvailableCount) {
                  this.showDialog(`轉贈${this.ticketTypeItem.unit}數錯誤`);
                } else if (this.offersType === this.ticketType.GiftPack.id) {
                    this.callGiftGiftPackApi(
                        this.couponId,
                        this.transAmount,
                        this.destToken,
                        this.destPhone,
                        this.remarks,
                        this.message,
                    );
                  } else {
                    this.callGiftCouponApi(
                        this.couponId,
                        this.endAtDate,
                        this.transAmount,
                        this.destToken,
                        this.destPhone,
                        this.remarks,
                        this.message,
                    );
                  }

            },

            /** 轉移票券 */
            callGiftCouponApi: function (couponId, endAtDate, transCount, destToken, destUserCode, remark, message) {
                this.isLoading = true;

                this.$http.fetchWithAuthEncrypt`GiftCoupon${{
                    couponId: couponId,    //優惠券 id
                    endAt: endAtDate,     //票券到期日
                    amount: Number(transCount),     //轉移張數
                    userToken: destToken,     //轉讓對象token
                    toUserCode: destUserCode,     //轉讓對象電話或 user code
                    myselfNote: remark,     //備註
                    toUserNote: message,     //留言
                    stageId: (this.stageInfo.stageId || 0)
                }}
                ${json => {
                    if (json.status) {
                        this.showDialog(`轉贈票券成功`);
                        this.dialogMsgMain=`剩餘${this.ticketTypeItem.unit}數<span class="red">${json.countGift}</span>${this.ticketTypeItem.unit}`
                        this.icons= require('@/assets/images/dialog_ticket.svg')
                        if (this.isGoBack) {
                            this.dialogResult = goToBack;
                        } else {
                            this.dialogResult = goToList;
                        }
                    } else {
                        this.showDialog('抱歉：' + json.message);
                    }
                    this.isLoading = false;
                }}`;
            },

            /** 取得票券詳情 */
            callGetMySelfCouponInfoByIdApi: function (id, couponId) {
                this.$http.fetchWithAuthEncrypt`GetMySelfCouponInfoById${{
                    id: id,
                    couponId: couponId
                }}
                 ${json => {
                    if (json.data !== null && json.data !== '') {
                        try {
                            json.data = this.$crypto.decryptObjectText(json.data)
                        } catch (e) {
                            //
                        }

                        this.commodityName = json.data.name;
                        this.content = json.data.content;
                        this.notice = json.data.contentPrecautions;
                        this.endAtDate = json.data.activityEnd;
                        this.convertEnd = json.data.convertEnd;
                        this.maxAvailableCount = json.data.countGift;
                        this.stageInfo = json.data.stageInfo;
                        this.isCertificate = json.data.isCertificate

                        this.numberControllerParams.max = this.maxAvailableCount;
                    }
                }
                }}`;
            },

            /** 確認轉贈對象 */
            doTargetConfirm: function (userId, userPhone, userCode) {
                if(userId === '' && userPhone === '' && userCode === '') {
                    this.showDialog('請輸入對方會員ID或電話號碼');
                    return false
                }

                this.callGetOtherUserInfoApi(userId, userPhone, userCode)
                    .then( this.showTargetConfirmDialog )
                    .catch( (error) => {
                        this.isLoading = false;
                        this.showDialog(error);
                        // self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });
            },

            /** 查轉贈對象資訊，任一條件有就尋找，最好只輸入其中一項資料 */
            callGetOtherUserInfoApi: function (userId = '', userPhone = '', userCode = '') {
                this.isLoading = true;

                let self = this;
                return new Promise(function (resolve, reject) {
                    self.$http.fetchWithAuthEncrypt`GetUserInfoData${{
                        userId: Number(userId),    //查詢對象的 userId
                        userCode: userCode,     //查詢對象的代號
                        phone: userPhone,     //查詢對象的電話
                    }} ${json => {

                        self.isLoading = false;
                        if (json.status) {
                            try {
                                json.data = self.$crypto.decryptObjectText(json.data)
                            } catch (e) {
                                //
                            }

                            if (json.data.isExist) {
                                self.tmpName = json.data.name;
                                self.tmpPhone = json.data.userCode;
                                self.tmpImg = json.data.picture;       //'https://file.oinapp.com/' +
                                resolve();
                            } else {
                                reject('沒有此會員');
                                self.dialogMsgMain = '請確認號碼輸入是否正確'
                            }
                        } else {
                            reject('沒有轉贈對象的資料');
                        }
                    }}`;
                });
            },
            numberControllerEvent(obj) {
                let self = this;
                let event = obj.event;

                if (event === "returnNumber") {
                    self.transAmount = obj.number
                } else if (event === "clickDisabledButton") {
                    if (obj.operate === "dec") {
                        this.showDialog(`${this.ticketTypeItem.unitName}不可少於 1 ${this.ticketTypeItem.unit}`);
                    }
                }
            },
            getMySelfGiftPackInfoById: function () {
                let self = this;
                self.isLoading = true;

                self.$http.fetchWithAuthEncrypt`GetGiftPackInfoById${{
                    id: self.couponId,
                    executeType: "getSelfGiftPack",
                }} ${json => {
                    if(json.status) {
                        let data = json.data
                        let giftPackInfo = data.giftPackInfo

                        self.commodityName = giftPackInfo.name;
                        self.maxAvailableCount = giftPackInfo.countGift;
                        self.giftMethodList = giftPackInfo.giftMethodList;

                        self.numberControllerParams.max = self.maxAvailableCount;
                        self.numberControllerIndex = self.numberControllerIndex + 1;
                    } else {
                        self.$public.showNotify(json.message, json.status);
                        if(!this.isWeb){
                            self.$router.go(-1);
                        }else {
                            //單店網頁版用
                            self.$emit('close',false);
                        }
                    }
                    self.isLoading = false;
                }
                }}`;
            },
            callGiftGiftPackApi: function (id, transCount, destToken, destUserCode, remark, message) {
                this.isLoading = true;

                this.$http.fetchWithAuthEncrypt`GiftGiftPack${{
                    id: id,
                    amount: Number(transCount),     //轉移張數
                    userToken: destToken,     //轉讓對象token
                    toUserCode: destUserCode,     //轉讓對象電話或 user code
                    myselfNote: remark,     //備註
                    toUserNote: message,     //留言
                }}
                ${json => {
                    if (json.status) {
                        this.showDialog(`轉贈${this.ticketTypeItem.unitName}成功`);
                        this.dialogMsgMain = `剩餘${this.ticketTypeItem.unit}數<span class="red">${json.countGift}</span>${this.ticketTypeItem.unit}`
                        this.icons = require('@/assets/images/dialog_ticket.svg')
                        if (this.isGoBack) {
                            this.dialogResult = goToBack;
                        } else {
                            this.dialogResult = goToList;
                        }
                    } else {
                        this.showDialog('抱歉：' + json.message);
                    }
                    this.isLoading = false;
                }}`;
            },
            goBack(){
                if(!this.isWeb){
                    this.$router.go(-1);
                }else {
                    //單店網頁版用
                    this.$emit('close',false);
                }
            },
        },
    }
</script>

<style lang="less" scoped src="../../less/transfer.less"/>